import React, { useState, useEffect } from 'react';
import { aiApi } from '../../lib/api';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { toast } from 'sonner';
import { Sparkles, Loader2, RefreshCw } from 'lucide-react';
import TestoAi from '../ai/TestoAi';

const MESI = ['Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno', 'Luglio',
  'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre'];

/** Commento del mese scritto dall'AI sui numeri già calcolati dal server. */
export const CommentoMensileCard = ({ anno, mese, isAdmin }) => {
  const [commento, setCommento] = useState(null);
  const [caricando, setCaricando] = useState(false);
  const [generando, setGenerando] = useState(false);

  useEffect(() => {
    if (!anno || !mese) return;
    setCaricando(true);
    aiApi.getCommento(anno, mese)
      .then((res) => setCommento(res.commento?.testo ? res.commento : null))
      .catch(() => setCommento(null))
      .finally(() => setCaricando(false));
  }, [anno, mese]);

  const genera = async () => {
    setGenerando(true);
    try {
      setCommento(await aiApi.generaCommento(anno, mese));
      toast.success('Commento del mese generato');
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Generazione non riuscita');
    } finally {
      setGenerando(false);
    }
  };

  if (!anno || !mese) return null;
  const etichetta = `${MESI[mese - 1]} ${anno}`;

  return (
    <Card data-testid="dashboard-commento-ai">
      <CardHeader className="pb-2">
        <CardTitle className="text-base flex items-center gap-2">
          <Sparkles className="w-4 h-4 text-primary" /> Commento di {etichetta}
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-3">
        {caricando && (
          <p className="text-sm text-muted-foreground flex items-center gap-2">
            <Loader2 className="w-4 h-4 animate-spin" /> Caricamento…
          </p>
        )}

        {!caricando && commento?.testo && (
          <>
            <TestoAi testo={commento.testo} />
            <p className="text-[11px] text-muted-foreground">
              Scritto dall’AI ({commento.modello}) il{' '}
              {(commento.generato_il || '').slice(8, 10)}/{(commento.generato_il || '').slice(5, 7)}/
              {(commento.generato_il || '').slice(0, 4)} sui numeri calcolati dal server.
            </p>
          </>
        )}

        {!caricando && !commento?.testo && (
          <p className="text-sm text-muted-foreground">
            Nessun commento per {etichetta}.
            {isAdmin ? ' Generalo per avere il riepilogo scritto del mese.' : ''}
          </p>
        )}

        {isAdmin && !caricando && (
          <Button
            variant={commento?.testo ? 'outline' : 'default'}
            size="sm"
            onClick={genera}
            disabled={generando}
            className="w-full"
            data-testid="commento-ai-genera"
          >
            {generando
              ? <><Loader2 className="w-4 h-4 mr-2 animate-spin" /> Sto scrivendo…</>
              : commento?.testo
                ? <><RefreshCw className="w-4 h-4 mr-2" /> Rigenera commento</>
                : <><Sparkles className="w-4 h-4 mr-2" /> Genera commento del mese</>}
          </Button>
        )}
      </CardContent>
    </Card>
  );
};

export default CommentoMensileCard;
